import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { customFieldEndpoints } from '@/lib/api/endpoints';
import { customFieldKeys } from '@/lib/queryKeys';
import type { CustomFieldSchema, CustomFieldEntityType } from '@/types/custom-fields';

export function useCustomFieldSchema(
  entityType: CustomFieldEntityType,
  includeInactiveDefinitions = false,
  // NOT-369 — when entityType is 'job', pass the job's job type id so the BE
  // drops JOB associations scoped to other job types (unscoped ones always
  // apply). Leave undefined to receive every association (e.g. the create form,
  // which filters client-side as the selected job type changes).
  jobTypeId?: string | null,
) {
  return useApiQuery<CustomFieldSchema[]>({
    // Pass `jobTypeId` through verbatim (NOT `?? null`) so an omitted job type
    // ('all' associations) keys distinctly from an explicit null/'' untyped job.
    queryKey: customFieldKeys.schema(entityType, includeInactiveDefinitions, jobTypeId),
    queryFn: () =>
      apiGet<CustomFieldSchema[]>(operationsClient, customFieldEndpoints.schema(), {
        params: {
          entityType,
          includeInactiveDefinitions,
          ...(jobTypeId !== undefined ? { jobTypeId: jobTypeId ?? '' } : {}),
        },
      }),
    enabled: !!entityType,
  });
}
